<template>
  <div class="container">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="keyword">
        <el-input v-model="queryParams.keyword" filterable placeholder="请输入账号/公司名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="mchId">
        <el-input v-model="queryParams.mchId" filterable placeholder="商户ID/商户名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click="adds">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" border :data="tableData" >
      <el-table-column type="index" align="center" />
      <el-table-column label="代理商名称" prop="companyName" align="center" min-width="160" :show-overflow-tooltip="true" />
      <el-table-column label="代理商层级" prop="companyPath" min-width="160" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="微信账号" prop="dictValue" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template #header>
          <div>
            <el-tooltip content="指定微信收款账号，此账号的卡，当选择微信支付时，都使用此收款账号结算，否则轮询系统收款账号结算" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
            <span>微信账号</span>
          </div>
        </template>
        <template slot-scope="{row}">
          <p>{{row.extra && row.extra.wxMchId ? row.extra.wxMchId : ''}}</p>
          <p style="font-size: 12px;">{{row.extra && row.extra.wxMchName ? row.extra.wxMchName : '系统账号轮询'}}</p>
        </template>
      </el-table-column>

      <el-table-column label="支付宝账号" prop="dictValue" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template #header>
          <div>
            <el-tooltip content="指定支付宝收款账号，此账号的卡，当选择支付宝支付时，都使用此收款账号结算，否则轮询系统收款账号结算" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
            <span>支付宝账号</span>
          </div>
        </template>
        <template slot-scope="{row}">
          <p>{{row.extra && row.extra.alipayMchId ? row.extra.alipayMchId : ''}}</p>
          <p style="font-size: 12px;">{{row.extra && row.extra.alipayMchName ? row.extra.alipayMchName : '系统账号轮询'}}</p>
        </template>
      </el-table-column>

      <el-table-column prop="dictValue" min-width="230" align="center" >
        <template #header>
          <div>
            <el-tooltip content="用户套餐充值时，可以选择那些支付方式" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
            <span>支付方式</span>
          </div>
        </template>
        <template slot-scope="{row}">
          <el-checkbox-group v-model="row.extra.payMode">
            <el-checkbox class="disabled-checkbox" label="1">微信</el-checkbox>
            <el-checkbox class="disabled-checkbox" label="2">支付宝</el-checkbox>
            <el-checkbox class="disabled-checkbox" label="3">云闪付</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-table-column>
      
      <el-table-column label="H5支付" prop="dictValue" min-width="80" align="center" :show-overflow-tooltip="true">
        <template #header>
          <div>
            <el-tooltip content="用户在浏览器（H5端）卡详情页面是否展示充值入口" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
            <span>H5支付</span>
          </div>
        </template>
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.extra && row.extra.wechatH5 =='1'">已开通</el-tag>
          <el-tag v-else type="danger">未开通</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="作用范围" prop="level" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <span v-if="row.level =='1'">当前账号</span>
          <span v-if="row.level =='2'">账号及下级</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="level" min-width="60" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <span v-if="row.status =='1'">有效</span>
          <span v-else>无效</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUser" min-width="100" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="创建时间" prop="createTime" min-width="120" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" min-width="70" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="text" v-hasPermi="['agent:dict:edit']" @click="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="text" v-hasPermi="['agent:dict:del']" @click="del(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="900px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="140px" ref="form" :rules="rules">
        <el-form-item label="代理商名称:" prop="userId">
          <el-select :disabled="!!form.id" v-model="form.userId" filterable placeholder="请选择代理商" clearable style="width:90%">
            <el-option v-for="(item,index) in agentData" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="wxMchId">
          <template slot="label">
            <el-tooltip effect="dark" content="指定微信收款账号，此账号的卡，当选择微信支付时，都使用此收款账号结算"  placement="top">
              <span><i class="el-icon-question" style="color: black;"></i>微信支付商号：</span>
            </el-tooltip>
          </template>
          <el-select v-model="form.wxMchId" filterable placeholder="请选择支付商号" @change="searchWxChat" clearable style="width:90%">
            <el-option v-for="(item,index) in wxMchSources" :key="index" :label="'['+item.mchId+']-' + item.name" :value="item.mchId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="wxChatData.length > 0">
          <div style="font-weight: 500;">此支付关联的公众号</div>
          <el-table :data="wxChatData" style="width:90%">
            <el-table-column prop="name" label="公众号名称"  align="center"  />
            <el-table-column prop="appid" label="APPID" align="center"  />
          </el-table>
        </el-form-item>
        <el-form-item prop="alipayMchId">
          <template slot="label">
            <el-tooltip effect="dark" content="指定支付宝收款账号，此账号的卡，当选择支付宝支付时，都使用此收款账号结算"  placement="top">
              <span><i class="el-icon-question" style="color: black;"></i>支付宝支付商号：</span>
            </el-tooltip>
          </template>
          <el-select v-model="form.alipayMchId" filterable placeholder="请选择支付商号" clearable style="width:90%">
            <el-option v-for="(item,index) in alipayMchSources" :key="index" :label="'['+item.mchId+']-' + item.name" :value="item.mchId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式:" prop="payMode">
          <template slot="label">
            <el-tooltip effect="dark" content="用户套餐充值时，可以选择那些支付方式"  placement="top">
              <span><i class="el-icon-question" style="color: black;"></i>支付方式:</span>
            </el-tooltip>
          </template>
          <el-checkbox-group v-model="form.payMode">
            <el-checkbox label="1">微信支付</el-checkbox>
            <el-checkbox label="2">支付宝支付</el-checkbox>
            <el-checkbox label="3">云闪付</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="H5支付:" prop="wechatH5">
          <template slot="label">
            <el-tooltip effect="dark" content="用户在浏览器（H5端）卡详情页面是否展示充值入口"  placement="top">
              <span><i class="el-icon-question" style="color: black;"></i>H5支付:</span>
            </el-tooltip>
          </template>
          <el-radio-group v-model="form.wechatH5">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="作用范围:" prop="level">
          <template slot="label">
            <el-tooltip effect="dark" content="以上配置是否只在当前账号的卡生效，还是当前账号以及下级账号的卡也生效"  placement="top">
              <span><i class="el-icon-question" style="color: black;"></i>作用范围:</span>
            </el-tooltip>
          </template>
          <el-radio-group v-model="form.level">
            <el-radio label="1">当前账号</el-radio>
            <el-radio label="2">当前账号及下级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态:" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentDictList , agentList , agentDictSave , agentDictUpdate , agentDictDel ,payConfigSource} from "@/api/api";
import { dictionaryPayList } from "@/api/api.js";
export default {
  name: "AgentPay",
  data() {
    return {
      queryParams:{
        mchName:undefined,
        mchId:undefined,
      },

      loading:false,
      tableData:[],
      title:'',
      dialog:false,
      wxMchSources:[],
      alipayMchSources:[],
      form:{
        id:undefined,
        userId:undefined,
        alipayMchId:undefined,
        wxMchId:undefined,
        dictValue:undefined,
        payMode:['1'],
        status:"1",
        wechatPublic:"1",
        wechatH5:"0",
        wechatProgram:"1",
        level:"1"
      },
      rules:{
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" }
        ],
        wxMchId:[
          { required: true, message: "请选择微信支付商号", trigger: "blur" }
        ],
        level:[
          { required: true, message: "请选择作用范围", trigger: "blur" }
        ]

      },
      agentData:[],
      wxChatData:[]

    };
  },
  methods:{
    //查询
    search(){
      this.initData()
    },
    //重置
    resetQuery(){
      this.resetForm("queryForm");
      this.search();
    },

    initData(){
      let key = "AgentPayConfig";
      agentDictList({key,keyword:this.queryParams.keyword,mchId:this.queryParams.mchId}).then(res=>{
        this.tableData = res.data.data
      })
    },
    //获取所有支付商号
    mchSource(){
      let status = '1';
      payConfigSource({status}).then(res=>{
        this.wxMchSources = res.data.data.filter(item=>item.type == '1');
        this.alipayMchSources = res.data.data.filter(item=>item.type == '2');
      })
    },
    //查找关联的公众号
    searchWxChat(mchId){
      if(!!mchId){
        dictionaryPayList({mchId}).then(res=>{
          this.wxChatData = res.data.data;
        })
      }
    },
    submitForm(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!!this.form.id) {
            this.form.dictKey = 'AgentPayConfig'
            this.form.dictValue = null
            this.form.dictValue = JSON.stringify(this.form)
            agentDictUpdate(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }else{
            this.form.dictKey = 'AgentPayConfig'
            this.form.dictValue = JSON.stringify(this.form)
            agentDictSave(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }
        }
      })
    },
    selectAgentList() {
      agentList().then(res => {
        this.agentData = res.data.data;
      });
    },
    adds(){
      this.dialog = true
      this.title = "新增代理商支付"
      this.wxChatData = []
      this.form={level:'1',payMode:['1'],wechatPublic:"1",wechatH5:"0",wechatProgram:"1",status:"1"}
    },
    edit(row){
      this.dialog = true
      this.title = "修改代理商支付"
      const extra = row.extra || '{}';
      let form = {
        id:row.id,
        userId : row.userId,
        dictValue : row.dictValue,
        level : row.level,
        status: row.status,
        wxMchId: extra.wxMchId,
        alipayMchId: extra.alipayMchId,
        payMode: extra.payMode || ['1'],
        wechatH5: extra.wechatH5 || "0",
      }
      this.form = form
      this.searchWxChat(extra.wxMchId)
    },
    //删除免显
    del(row){
      let id = row.id
      this.$confirm("此操作将删除此代理商支付，恢复系统支付, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        agentDictDel({id}).then(res=>{
          this.$notify({
            title: '成功',
            message: '代理商支付配置删除成功',
            type: 'success'
          });
          this.initData();
        })
      })
    }
  },
  created() {
    this.initData()
    this.mchSource()
    this.selectAgentList()
  },
};
</script>
<style scoped lang="less">
::v-deep .disabled-checkbox{
  pointer-events: none !important;
  cursor: default !important;
  margin-right: 8px;
}
</style>